import { render } from "./orderRequestPost.vue?vue&type=template&id=4a9e8506&scoped=true"
import script from "./orderRequestPost.vue?vue&type=script&lang=js"
export * from "./orderRequestPost.vue?vue&type=script&lang=js"

import "./orderRequestPost.vue?vue&type=style&index=0&id=4a9e8506&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a9e8506"

export default script